// Module
var code = "<div class=\"row\"> <div class=\"col-md-12\"> <thing-documentation-element *ngFor=\"let doc of thingDefinitionDocumentations\" [thingDefinitionDocumentation]=\"doc.doc\" [Url]=\"doc.url\" (click)=\"openFile(doc.doc)\"> </thing-documentation-element> </div> </div>";
// Exports
module.exports = code;